import { render, staticRenderFns } from "./UserAccessesTab.vue?vue&type=template&id=410e6810&scoped=true"
import script from "./UserAccessesTab.vue?vue&type=script&lang=js"
export * from "./UserAccessesTab.vue?vue&type=script&lang=js"
import style0 from "./UserAccessesTab.vue?vue&type=style&index=0&id=410e6810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410e6810",
  null
  
)

export default component.exports